// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3t_5i","title":"ClientReferral_title__3khGH","itemText":"ClientReferral_itemText__3UxmH"};